import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_40 implements Validator {

	public static id = 'CTRL_40';
	private message = 'error.ctr_40';


	public LOG: LogService = new LogService(CTRL_40);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_40.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChampNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdChampNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId]?.value;;
                const secondChampCtrl = form.controls[secondChampNameWithStepId]?.value;;
                const thirdChampCtrl = form.controls[thirdChampNameWithStepId]?.value;;
				let adresse = (firstChampCtrl?.length || 0) + (secondChampCtrl?.length || 0)  + (thirdChampCtrl?.length || 0);

                if (adresse > 0 && adresse < 5) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}
}
